module.exports = __webpack_public_path__ + "6053833dba4814a920a4286f79aefb9b.png";